module.exports = __webpack_public_path__ + "kudos_26.svg?bd12060e06ddf8c2910f96c6c7fea8b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_26.svg
// module id = 124
// module chunks = 0